import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CustomizedApplicationPayload, ErrorContext } from '@ca/core/models';
import { Observable } from 'rxjs';
import { errorContextToken } from '../interceptors/global-error.interceptor';
import { ErrorReport } from '../models/customer-support-model';

@Injectable()
export class SupportService {
    readonly API_URL = '/api/customer_support';

    constructor(private http: HttpClient) {}

    reportError$(errorReport: ErrorReport): Observable<{}> {
        return this.http.post(`${this.API_URL}/reportError`, errorReport);
    }

    requestApplication$(payload: CustomizedApplicationPayload): Observable<void> {
        const errorContext: ErrorContext = { isEnabled: true, errors: [{ code: 500, key: 'APPLICATIONS.REQUEST_CUSTOMIZED_APPLICATION.ERRORS.CREATE' }] };
        return this.http.post<void>(`${this.API_URL}/application`, payload, {
            context: new HttpContext().set(errorContextToken, errorContext),
        });
    }

    sendFeedback$(senderFullName: string, email: string, message: string, smileyCode: string, resultLinkPrefix: string, resultId: string): Observable<{}> {
        const body = {
            senderfullName: senderFullName,
            senderemailaddress: email,
            message,
            smiley: smileyCode,
            resultlinkprefix: resultLinkPrefix,
            resultid: resultId,
        };
        return this.http.post(`${this.API_URL}/feedback`, body);
    }
}
